module.exports = __webpack_public_path__ + "media/fold.d12894d1.mp3";